const u = (id, w = 900) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const heroImages = {
  farmLandscape: u("1500382017468-9049fed747ef", 1600),
  harvestHands: u("1523348837708-15d4a09cfac2", 1200),
  spiceMarket: u("1509358271058-acd22cc93898", 1200),
  basket: u("1488459716781-31db52582fe9", 1200),
};

export const aboutImages = {
  farmer: u("1625246333195-78d9c38ad449", 1200),
  fieldWide: u("1464226184884-fa280b87c399", 1600),
  warehouse: u("1586528116311-ad8dd3c8310d", 1200),
  shipping: u("1578575437130-527eed3abbec", 1400),
  logistics: u("1493946740644-2d8a1f1a6aff", 1400),
};

export const productImages = {
  onion: "/assets/Onion.jpg",
  greenChilli: "/assets/Green-chilli.jpg",
  ginger: "/assets/Ginger.jpg",
  coconut: "/assets/Coconut.jpg",
  okra: "/assets/Okra.jpg",
  sweetCorn: u("1551754655-cd27e38d2076"),

  blackPepper: "/assets/black-pepper.jpg",
  cardamom: "/assets/green-cardamon.jpg",
  cinnamon: "/assets/Cinnamon.jpg",
  cumin: "/assets/Cumin.jpg",
  turmeric: "/assets/Turmeric.jpg",
  coriander: "/assets/Coriander.jpg",

  banana: u("1603833665858-e61d17a86224"),
  pomegranate: "/assets/pomogranate.jpg",
  mango: u("1553279768-865429fa0078"),
  tableGrapes: "/assets/Grapes.jpg",

  cornCob: "/assets/corn-cob.jpg",
  raisins: "/assets/Raisins.jpg",
  dehydratedVegetables: "/assets/Dehydrated-vegertables.jpg",
};

// Three distinct "detail" photos per product, used for thumbnails 2-4 on
// the product detail gallery (thumbnail 1 mirrors the main hero image).
// Keyed by product slug; falls back to the main image if a slug is missing.
// Every ID below was downloaded and visually checked to confirm it depicts
// the right product and that the three are visually distinct from each other.
export const productGalleries = {
  // ── Vegetables ──
  onion: [u("1618512496248-a07fe83aa8cb"), u("1575475240735-0b191257c762"), u("1664975367131-4c7ac2efa704")],
  potato: [u("1518977676601-b53f82aba655"), u("1590165482129-1b8b27698780"), u("1675501344642-92d35d90fe51")],
  "green-chilli": [u("1599987141071-f5810d32e21a"), u("1693664132282-29467c147940"), u("1763221126437-ebf2339c7b67")],
  okra: [u("1425543103986-22abb7d7e8d2"), u("1568640895956-e2bad65027b0"), u("1664289242854-e99d345cfa92")],
  "sweet-corn": [u("1634467524884-897d0af5e104"), u("1531171000775-75f0213ca8a0"), u("1649251037566-6881b4956615")],
  ginger: [u("1630623093145-f606591c2546"), u("1573414405995-2012861b74e0"), u("1635008388183-04ea0313c5d1")],

  // ── Fruits ──
  pomegranate: [u("1574709755254-fcd942d09d5a"), u("1601767770428-265b2c67780c"), u("1597854710119-dbb43d562f78")],
  banana: [u("1571152557337-9ab79fd76eb3"), u("1619995750009-5256e91437b0"), u("1739664237734-e6e9b91bfd0d")],
  mango: [u("1601493700631-2b16ec4b4716"), u("1553279768-865429fa0078"), u("1635716279493-d1e30afc25a0")],
  "table-grapes": [u("1596363505729-4190a9506133"), u("1631299106224-aae61c217164"), u("1698305819486-ecca56daaba3")],
  coconut: [u("1560769680-ba2f3767c785"), u("1597636319015-1fce74db8798"), u("1588413335653-34b770bca7c1")],

  // ── Spices ──
  turmeric: [u("1606951444141-e5533feb55be"), u("1615485500834-bc10199bc727"), u("1702041295331-840d4d9aa7c9")],
  cumin: [u("1701189975842-591ebd1e26a2"), u("1601723897386-e5df0c749fb7"), u("1587493053604-f943541023aa")],
  coriander: [u("1608797179072-4268dd68eff2"), u("1508748169069-82590c9f26e6"), u("1528613526328-8c19bd037322")],
  "black-pepper": [u("1591801058986-9e28e68670f7"), u("1506085621370-98b475435879"), u("1649951806971-ad0e00408773")],
  cardamom: [u("1622824497447-b284a5493027"), u("1763558049571-a6d12a85472e"), u("1642255486695-a52c59347cfa")],
  cinnamon: [u("1601379760622-0d2e7ad24c11"), u("1636972955024-3b01f2236b01"), u("1553499944-e4297a0af1bd")],

  // ── Processed ──
  "dehydrated-vegetables": [u("1731985318570-19fc207fedfa"), u("1541675955960-b9c87e17883d"), u("1682221853269-810b704515a6")],
  "fruit-pulps": [u("1620878439728-a8f735a95e3f"), u("1642614696258-6eadac9705f0"), u("1629180050285-7c56c6671f19")],
  raisins: [u("1642102903918-b97c37955bbf"), u("1608842850202-06e70ead4c10"), u("1621597121291-fa650ac736e5")],
  "iqf-corn": [u("1551754655-cd27e38d2076"), u("1578652903016-b78571b87410"), u("1623066798929-946425dbe1b0")],
};

export const categoryHeroes = {
  vegetables: u("1518977676601-b53f82aba655", 1400),
  spices: u("1509358271058-acd22cc93898", 1400),
  fruits: u("1519996529931-28324d5a630e", 1400),
  processed: u("1506368249639-73a05d6f6488", 1400),
};

export const globalImages = {
  port: u("1578575437130-527eed3abbec", 1600),
  containers: u("1493946740644-2d8a1f1a6aff", 1600),
  world: u("1451187580459-43490279c0fa", 1600),
  aerial: u("1569428034239-f9565e32e224", 1600),
};
